<template>
	<v-app>
		<v-main class="login-supplier">
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar color="cyan darken-2" dark flat>
								<v-toolbar-title class="text-capitalize">login supplier</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<v-card-text>
								<v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
									<v-alert dense color="red lighten-1 f" class="white--text" dismissible v-for="alert in this.alerts" :key="alert.id"> {{alert.message}} </v-alert>
									<v-text-field required :rules="usernameRules" @focus="() => fieldErrors.username=''" :error-messages="fieldErrors.username" placeholder="Username" name="login" prepend-icon="mdi-account" type="text" v-model="username" color="cyan darken-3"></v-text-field>
									<v-text-field required :rules="passwordRules" @focus="() => fieldErrors.password=''" :error-messages="fieldErrors.password" id="password" placeholder="Kata Sandi" name="password" prepend-icon="mdi-lock" type="password" v-model="password" color="cyan darken-3" :append-icon="iconPass" @click:append="showPassword" single-line></v-text-field>
									<v-layout column align-end class="pt-5">
										<v-flex>
											<v-btn dark color="cyan darken-2" type="submit">Login</v-btn>
										</v-flex>
									</v-layout>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('authSupplier');

export default {
	data() {
		return {
			username: '',
			password: '',
			iconPass: 'mdi-eye',
			passwordRules: [
			v => !!v || 'Kata Sandi tidak boleh kosong',
			],
		}
	},
	props: {
		source: String,
	},
	computed: {
		...mapState(['fieldErrors', 'alerts']),
	},
	methods: {
		...mapMutations(['removeAlert', 'reset']),
		...mapActions(['login']),

		onLogin() {
			if	(this.$refs.formLogin.validate())
			{
				this.login({ username: this.username, password: this.password }).then(() => {
					const { redirect } = this.$route.query;

					if (redirect == "/supplier" || !redirect) {
						this.$router.push({ name: "dashboard-supplier" })
					} else {
						this.$router.push(redirect);
					}
				});
			}
		},
		showPassword() {
			var x = document.getElementById("password");
			if (x.type === "password") {
				x.type = "text"
				this.iconPass = 'mdi-eye-off'
			} else {
				x.type = "password"
				this.iconPass = 'mdi-eye'
			}
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Login Supplier`)
	}
}
</script>